import React from 'react';
import {Path} from "../../components/svg/components/path";
import {Svg} from "../../components/svg/components/Svg";
import classNames from "classnames";
import styles from "./keyboard-arrow.module.scss";

export const KeyboardArrowLeft = ({className, onClick, style}) => {
  return <Svg className={classNames(className, styles.default)} style={style} onClick={() => onClick && onClick()}>
    <Path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/>
  </Svg>
}
